module.exports = __webpack_public_path__ + "src/assets/fonts/OpenSans-ExtraBold.otf";